/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AccountCodeValidation,
    AccountCodeValidationFromJSON,
    AccountCodeValidationFromJSONTyped,
    AccountCodeValidationToJSON,
    CardPoolSettingsValidation,
    CardPoolSettingsValidationFromJSON,
    CardPoolSettingsValidationFromJSONTyped,
    CardPoolSettingsValidationToJSON,
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface VccCredentialsUpdateRequestValidationData
 */
export interface VccCredentialsUpdateRequestValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsUpdateRequestValidationData
     */
    id?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsUpdateRequestValidationData
     */
    accountCodes?: ValidationMessage;
    /**
     * 
     * @type {Array<AccountCodeValidation>}
     * @memberof VccCredentialsUpdateRequestValidationData
     */
    readonly accountCodesRestrictions?: Array<AccountCodeValidation> | null;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsUpdateRequestValidationData
     */
    agentId?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsUpdateRequestValidationData
     */
    apiKey?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsUpdateRequestValidationData
     */
    bookerId?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsUpdateRequestValidationData
     */
    brandAndMarket?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsUpdateRequestValidationData
     */
    cardSupplier?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsUpdateRequestValidationData
     */
    clientId?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsUpdateRequestValidationData
     */
    consumer?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsUpdateRequestValidationData
     */
    effectiveDates?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsUpdateRequestValidationData
     */
    email?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsUpdateRequestValidationData
     */
    server?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsUpdateRequestValidationData
     */
    url?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsUpdateRequestValidationData
     */
    uniqueness?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsUpdateRequestValidationData
     */
    addressLine1?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsUpdateRequestValidationData
     */
    addressLine2?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsUpdateRequestValidationData
     */
    city?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsUpdateRequestValidationData
     */
    country?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsUpdateRequestValidationData
     */
    zip?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsUpdateRequestValidationData
     */
    username?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsUpdateRequestValidationData
     */
    organisationId?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsUpdateRequestValidationData
     */
    merchantId?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsUpdateRequestValidationData
     */
    bankId?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsUpdateRequestValidationData
     */
    companyId?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof VccCredentialsUpdateRequestValidationData
     */
    cardPoolSettings?: ValidationMessage;
    /**
     * 
     * @type {Array<CardPoolSettingsValidation>}
     * @memberof VccCredentialsUpdateRequestValidationData
     */
    readonly cardPoolSettingsRestrictions?: Array<CardPoolSettingsValidation> | null;
}

export function VccCredentialsUpdateRequestValidationDataFromJSON(json: any): VccCredentialsUpdateRequestValidationData {
    return VccCredentialsUpdateRequestValidationDataFromJSONTyped(json, false);
}

export function VccCredentialsUpdateRequestValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): VccCredentialsUpdateRequestValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : ValidationMessageFromJSON(json['id']),
        'accountCodes': !exists(json, 'accountCodes') ? undefined : ValidationMessageFromJSON(json['accountCodes']),
        'accountCodesRestrictions': !exists(json, 'accountCodesRestrictions') ? undefined : (json['accountCodesRestrictions'] === null ? null : (json['accountCodesRestrictions'] as Array<any>).map(AccountCodeValidationFromJSON)),
        'agentId': !exists(json, 'agentId') ? undefined : ValidationMessageFromJSON(json['agentId']),
        'apiKey': !exists(json, 'apiKey') ? undefined : ValidationMessageFromJSON(json['apiKey']),
        'bookerId': !exists(json, 'bookerId') ? undefined : ValidationMessageFromJSON(json['bookerId']),
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : ValidationMessageFromJSON(json['brandAndMarket']),
        'cardSupplier': !exists(json, 'cardSupplier') ? undefined : ValidationMessageFromJSON(json['cardSupplier']),
        'clientId': !exists(json, 'clientId') ? undefined : ValidationMessageFromJSON(json['clientId']),
        'consumer': !exists(json, 'consumer') ? undefined : ValidationMessageFromJSON(json['consumer']),
        'effectiveDates': !exists(json, 'effectiveDates') ? undefined : ValidationMessageFromJSON(json['effectiveDates']),
        'email': !exists(json, 'email') ? undefined : ValidationMessageFromJSON(json['email']),
        'server': !exists(json, 'server') ? undefined : ValidationMessageFromJSON(json['server']),
        'url': !exists(json, 'url') ? undefined : ValidationMessageFromJSON(json['url']),
        'uniqueness': !exists(json, 'uniqueness') ? undefined : ValidationMessageFromJSON(json['uniqueness']),
        'addressLine1': !exists(json, 'addressLine1') ? undefined : ValidationMessageFromJSON(json['addressLine1']),
        'addressLine2': !exists(json, 'addressLine2') ? undefined : ValidationMessageFromJSON(json['addressLine2']),
        'city': !exists(json, 'city') ? undefined : ValidationMessageFromJSON(json['city']),
        'country': !exists(json, 'country') ? undefined : ValidationMessageFromJSON(json['country']),
        'zip': !exists(json, 'zip') ? undefined : ValidationMessageFromJSON(json['zip']),
        'username': !exists(json, 'username') ? undefined : ValidationMessageFromJSON(json['username']),
        'organisationId': !exists(json, 'organisationId') ? undefined : ValidationMessageFromJSON(json['organisationId']),
        'merchantId': !exists(json, 'merchantId') ? undefined : ValidationMessageFromJSON(json['merchantId']),
        'bankId': !exists(json, 'bankId') ? undefined : ValidationMessageFromJSON(json['bankId']),
        'companyId': !exists(json, 'companyId') ? undefined : ValidationMessageFromJSON(json['companyId']),
        'cardPoolSettings': !exists(json, 'cardPoolSettings') ? undefined : ValidationMessageFromJSON(json['cardPoolSettings']),
        'cardPoolSettingsRestrictions': !exists(json, 'cardPoolSettingsRestrictions') ? undefined : (json['cardPoolSettingsRestrictions'] === null ? null : (json['cardPoolSettingsRestrictions'] as Array<any>).map(CardPoolSettingsValidationFromJSON)),
    };
}

export function VccCredentialsUpdateRequestValidationDataToJSON(value?: VccCredentialsUpdateRequestValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': ValidationMessageToJSON(value.id),
        'accountCodes': ValidationMessageToJSON(value.accountCodes),
        'agentId': ValidationMessageToJSON(value.agentId),
        'apiKey': ValidationMessageToJSON(value.apiKey),
        'bookerId': ValidationMessageToJSON(value.bookerId),
        'brandAndMarket': ValidationMessageToJSON(value.brandAndMarket),
        'cardSupplier': ValidationMessageToJSON(value.cardSupplier),
        'clientId': ValidationMessageToJSON(value.clientId),
        'consumer': ValidationMessageToJSON(value.consumer),
        'effectiveDates': ValidationMessageToJSON(value.effectiveDates),
        'email': ValidationMessageToJSON(value.email),
        'server': ValidationMessageToJSON(value.server),
        'url': ValidationMessageToJSON(value.url),
        'uniqueness': ValidationMessageToJSON(value.uniqueness),
        'addressLine1': ValidationMessageToJSON(value.addressLine1),
        'addressLine2': ValidationMessageToJSON(value.addressLine2),
        'city': ValidationMessageToJSON(value.city),
        'country': ValidationMessageToJSON(value.country),
        'zip': ValidationMessageToJSON(value.zip),
        'username': ValidationMessageToJSON(value.username),
        'organisationId': ValidationMessageToJSON(value.organisationId),
        'merchantId': ValidationMessageToJSON(value.merchantId),
        'bankId': ValidationMessageToJSON(value.bankId),
        'companyId': ValidationMessageToJSON(value.companyId),
        'cardPoolSettings': ValidationMessageToJSON(value.cardPoolSettings),
    };
}


